import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function AuthorPage() {
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16 md:pb-20">
        <div className="px-4 md:px-6 max-w-[800px] mx-auto">
          <nav className="text-xs text-foreground-500 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-foreground-900 cursor-pointer transition-colors">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-foreground-700 font-medium">Chi Siamo</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-8">Chi Siamo</h1>

          <div className="space-y-6 text-foreground-700 leading-relaxed text-sm">
            <p>
              Siamo un team di appassionati di shopping internazionale con oltre cinque anni di esperienza 
              nell&apos;acquisto di prodotti dai marketplace cinesi. La nostra missione è rendere accessibile 
              a tutti gli italiani il mondo di <strong>Itaobuy Spreadsheet</strong>, uno strumento che abbiamo 
              creato e perfezionato nel tempo per semplificare la scoperta e l&apos;acquisto di prodotti di qualità 
              dalla Cina.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">La Nostra Esperienza</h2>
            <p>
              Abbiamo testato personalmente centinaia di prodotti, verificato decine di agent di shipping, 
              e analizzato migliaia di foto QC prima di creare lo spreadsheet che oggi condividiamo con la 
              comunità italiana. La nostra esperienza diretta sul campo ci permette di offrire consigli 
              pratici e affidabili, basati su acquisti reali e non su semplici ricerche online.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Il Nostro Metodo di Ricerca</h2>
            <p>
              Ogni prodotto presente nel nostro spreadsheet segue un rigoroso processo di valutazione in cinque fasi:
            </p>
            <ol className="list-decimal pl-5 space-y-2">
              <li><strong>Scoperta:</strong> Identifichiamo prodotti interessanti su Taobao, Weidian e altri marketplace.</li>
              <li><strong>Verifica:</strong> Controlliamo l&apos;affidabilità del venditore attraverso recensioni e storico.</li>
              <li><strong>Acquisto Test:</strong> Acquistiamo il prodotto per valutarne la qualità reale.</li>
              <li><strong>Analisi QC:</strong> Esaminiamo le foto QC per confrontare il prodotto reale con le immagini del venditore.</li>
              <li><strong>Pubblicazione:</strong> Solo dopo aver superato tutte le verifiche, il prodotto viene aggiunto allo spreadsheet.</li>
            </ol>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Criteri di Analisi</h2>
            <p>
              Valutiamo ogni prodotto secondo criteri rigorosi: qualità dei materiali, accuratezza delle taglie, 
              fedeltà alle foto promozionali, rapporto qualità-prezzo, affidabilità del venditore e velocità 
              di spedizione. Solo i prodotti che raggiungono un punteggio elevato in tutte le categorie vengono 
              inclusi nel nostro database.
            </p>

            <div className="mt-10 p-5 bg-background-100 rounded-xl">
              <p className="text-sm">
                <strong className="text-foreground-900">Contattaci:</strong> Per domande, suggerimenti o collaborazioni, 
                visita il nostro sito principale{' '}
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 cursor-pointer">
                  Kaspreadsheet
                </a>.
              </p>
            </div>

            <div className="mt-8">
              <Link to="/" className="text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors">
                &larr; Torna alla Home
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Itaobuy Spreadsheet',
            url: 'https://itaobuyspread.pics',
            description: 'Team di esperti di shopping internazionale con oltre cinque anni di esperienza nell\'acquisto di prodotti dai marketplace cinesi',
            foundingDate: '2021',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              url: 'https://kaspreadsheet.com',
            },
            sameAs: [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />
    </>
  );
}